/* eslint-disable react/no-danger */
import React from 'react';

import { IMG_ETOILE_URL } from 'common/configuration/constants';
import { ACCOUNT_CONFIRMED_SUCCESS } from 'common/module/ui/lazy-modal/constant-types';
import buildReactDomModalModule from 'common/module/ui/lazy-modal/react-dom-modal-module';
import ReactModal from 'common/module/ui/lazy-modal/react-modal';
import trans from 'common/tools/translations/trans';

const AccountConfirmedSuccessModal = () => {
  return (
    <ReactModal
      size="small"
      className="modal-welcome"
      image={IMG_ETOILE_URL}
      imageWidth={246}
      imageHeight={92}
      title={trans('userspace.account-action.success.title')}
    >
      <p className="vertical-spacing">
        {trans('userspace.account-action.success.list-head')}
      </p>
      <ul className="list">
        <li
          className="list-item vertical-spacing"
          dangerouslySetInnerHTML={{
            __html: trans('userspace.account-action.success.list-item-1')
          }}
        />
        <li
          className="list-item vertical-spacing"
          dangerouslySetInnerHTML={{
            __html: trans('userspace.account-action.success.list-item-2')
          }}
        />
        <li
          className="list-item vertical-spacing"
          dangerouslySetInnerHTML={{
            __html: trans('userspace.account-action.success.list-item-3')
          }}
        />
        <li
          className="list-item"
          dangerouslySetInnerHTML={{
            __html: trans('userspace.account-action.success.list-item-4')
          }}
        />
      </ul>
      <button
        type="button"
        className="button button-inverse-full js-trigger-overlay-close"
      >
        {trans('userspace.account-action.success.button-text')}
      </button>
    </ReactModal>
  );
};

export default buildReactDomModalModule(ACCOUNT_CONFIRMED_SUCCESS, () => (
  <AccountConfirmedSuccessModal />
));
